import { ReactComponent as OutlineEyeClosed } from "assets/svg/outline-eye-closed.svg";
import { ReactComponent as OutlineEyeOpen } from "assets/svg/outline-eye-open.svg";
import isFreeOfCharge from "components/Dashboard/DoctorDashboard/views/one-one-sessions/utils/isFreeOfCharge";
import SESSION_TYPE_COLORS from "components/Dashboard/utility/constants/session-type-colors";
import messages from "messages";
import getClasses from "utils/getClasses";
import styles from "./SessionTypeSelector.module.scss";

interface SessionTypeItemProps {
  sessionType: SessionType;
}

const SessionTypeItem = ({ sessionType }: SessionTypeItemProps) => {
  if (!sessionType) {
    return null;
  }
  const colorValue =
    SESSION_TYPE_COLORS.find((color) => color.id === sessionType.color_code)
      ?.value ?? "";
  return (
    <div className={styles["item"]}>
      <div
        className={getClasses(
          styles["item-field"],
          styles["item-field--color-code"],
        )}
        style={{
          backgroundColor: colorValue,
        }}
      />
      <div
        className={getClasses(
          styles["item-field"],
          styles["item-field--label"],
        )}
      >
        {sessionType.label}
      </div>
      <div
        className={getClasses(
          styles["item-field"],
          styles["item-field--length"],
        )}
      >
        {`${sessionType.length_min} ${messages.minutesShort}`}
      </div>
      <div
        className={getClasses(
          styles["item-field"],
          styles["item-field--price"],
        )}
      >
        {/* remove undefined, sincel +undefined is NaN */}
        {isFreeOfCharge(sessionType.price)
          ? messages.free
          : `$ ${(typeof sessionType.price === "string"
              ? +sessionType.price
              : sessionType.price
            ).toFixed(2)}`}
      </div>
      <div
        className={getClasses(styles["item-field"], styles["item-field--icon"])}
      >
        {sessionType.invite_only ? <OutlineEyeClosed /> : <OutlineEyeOpen />}
      </div>
    </div>
  );
};

export default SessionTypeItem;
